import Card, { CardTitle } from "./Card";
import React, { useState } from "react";
import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "../../posts/constants";
import DonutGraph from "components/DonutGraph";
import CompareModal from "./CompareModal";
import { COLORS } from "utils/styles.js";
import { getAudienceEmoji } from "posts/constants";

export default function RaceCard({ activeAudience }) {
  const renderData = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        // Note: Color is added for the onMouseOver() function in DonutGraph component
        // white, black, and latinx (a/-a + PI), OTHER

        return [
          { x: "Asian (A)", y: 3.5, color: "#B3E1E5", initials: "A" },
          { x: "Black (B)", y: 9, color: "#8CD3D9", initials: "B" },
          { x: "Latinx (LX)", y: 15, color: "#66C4CC", initials: "LX" },
          { x: "White (W)", y: 65, color: "#40B5BF", initials: "W" },
          { x: "Other (O)", y: 7.5, color: "#339199", initials: "O" },
        ];
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return [
          { x: "Asian (A)", y: 1, color: "#FFD8CC", initials: "A" },
          { x: "Black (B)", y: 3, color: "#FFB399", initials: "B" },
          { x: "Latinx (LX)", y: 16, color: "#FF8C66", initials: "LX" },
          { x: "White (W)", y: 80, color: "#FF6633", initials: "W" },
          { x: "Other (O)", y: 8, color: "#FF4000", initials: "O" },
        ];
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return [
          { x: "Asian (A)", y: 2, color: "#FFE6FF", initials: "A" },
          { x: "Black (B)", y: 18, color: "#FFCCFF", initials: "B" },
          { x: "Latinx (LX)", y: 16, color: "#FFB3FF", initials: "LX" },
          { x: "White (W)", y: 56, color: "#FF99FF", initials: "W" },
          { x: "Other (O)", y: 6.5, color: "#E052E0", initials: "O" },
        ];
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return [
          { x: "Asian (A)", y: 3.2, color: "#E0D3B8", initials: "A" },
          { x: "Black (B)", y: 22, color: "#D1BD94", initials: "B" },
          { x: "Latinx (LX)", y: 18, color: "#C2A770", initials: "LX" },
          { x: "White (W)", y: 50, color: "#B3914D", initials: "W" },
          { x: "Other (O)", y: 7, color: "#8F743D", initials: "O" },
        ];
    }
  };

  const renderColorScale = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return COLORS.TOUGH_COOKIES_PALETTE;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return COLORS.DONT_TREAD_ON_ME_PALETTE;
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return COLORS.PEOPLE_POWER_PALETTE;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return COLORS.IF_YOU_SAY_SO_PALETTE;
    }
  };

  const data = renderData(activeAudience);
  const colors = renderColorScale(activeAudience);

  const [showCompare, setShowCompare] = useState(false);

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Race
      </CardTitle>

      <DonutGraph name="RaceChart" data={data} colors={colors} extras="" />

      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Race</CompareModal.Title>
        </CompareModal.Header>{" "}
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`race-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    <DonutGraph
                      colors={renderColorScale(type)}
                      data={renderData(type)}
                      extras=""
                    />
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}
